import { render, staticRenderFns } from "./smartLearn.vue?vue&type=template&id=02dd9d10&scoped=true&"
import script from "./smartLearn.vue?vue&type=script&lang=js&"
export * from "./smartLearn.vue?vue&type=script&lang=js&"
import style0 from "./smartLearn.vue?vue&type=style&index=0&id=02dd9d10&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dd9d10",
  null
  
)

export default component.exports